<template>
    <v-chart ref="line" :options="option"/>
</template>

<script>
    import ECharts from 'vue-echarts'
    import 'echarts/lib/chart/line'
    import 'echarts-gl'
    export default {
        name: "UserFeatureLineECharts",
        components: {
            'v-chart': ECharts,
        },
        props:{
            lineData:Object
        },
        watch:{
           lineData:function (newVal,oldVal) {
               this.$refs.line.clear();
               this.option.legend.data = newVal.settings.legend;
               if (newVal.settings.legend.length > 10){
                   this.option.tooltip.position = function (pos, params, dom, rect, size) {
                       // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
                       var obj = {top: -100};
                       obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
                       return obj;
                   }
               }
               this.option.xAxis.data = newVal.settings.xAxis;
               this.option.series = newVal.data;
               this.loaded()
           }
        },
        data(){
            return {
                option: {
                    tooltip: {
                        trigger: 'axis',
                    },
                    legend: {
                        type:"scroll",
                        // data: ['邮件营销', '联盟广告', '视频广告', '直接访问', '搜索引擎','解决','看看'],
                        data: [],
                        left: 'center'
                    },
                    grid: {
                        // top:'20%',
                        top:'13%',
                        left: '0',
                        right: '5%',
                        bottom: '0',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        // {
                        //     name: '邮件营销',
                        //     type: 'line',
                        //     // stack: '总量',
                        //     data: [120, 132, 101, 134, 90, 230, 210]
                        // },
                        // {
                        //     name: '联盟广告',
                        //     type: 'line',
                        //     // stack: '总量',
                        //     data: [220, 182, 191, 234, 290, 330, 310]
                        // },
                        // {
                        //     name: '视频广告',
                        //     type: 'line',
                        //     // stack: '总量',
                        //     data: [150, 232, 201, 154, 190, 330, 410]
                        // },
                        // {
                        //     name: '直接访问',
                        //     type: 'line',
                        //     // stack: '总量',
                        //     data: [320, 332, 301, 334, 390, 330, 320]
                        // },
                        // {
                        //     name: '搜索引擎',
                        //     type: 'line',
                        //     // stack: '总量',
                        //     data: [820, 932, 901, 934, 1290, 1330, 1320]
                        // },
                    ]
                }
            }
        },
        methods:{
            loading(){
                this.$refs.line.showLoading()
            },
            loaded(){
                this.$refs.line.hideLoading()
            }
        }
    }
</script>

<style scoped>
    .echarts{
        width: 100%;
        height: 100%;
    }
</style>